import { render, staticRenderFns } from "./questionArea.vue?vue&type=template&id=61e06612&scoped=true&"
import script from "./questionArea.vue?vue&type=script&lang=js&"
export * from "./questionArea.vue?vue&type=script&lang=js&"
import style0 from "./questionArea.vue?vue&type=style&index=0&id=61e06612&prod&lang=less&scoped=true&"
import style1 from "./questionArea.vue?vue&type=style&index=1&id=61e06612&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e06612",
  null
  
)

export default component.exports